const ChevronDown = ({ size = 24 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <path
        d="M5.293 8.293a1 1 0 0 1 1.414 0L12 13.586l5.293-5.293a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414Z"
        fillRule="evenodd"
        fill="currentColor"
      />
    </svg>
  );
};

export default ChevronDown;
